export const tr = {
    emptyPayer: 'Ödeyeni seçin',
    emptyPaymentMethod: 'Ödeme yöntemini seçin',
    emptySum: 'Kapatma sınırı değerini belirtin',
    gteMessage: 'Kapatma sınırı mümkün olan en yüksek değerin {maxValue} {currency} üzerinde',
    lteMessage: 'Kapatma sınırı mümkün olan en düşük değerin {minValue} {currency} altında',
    nanSum: 'Kapatma sınırı değeri yanlış'
};
